var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-footer"},[_c('span',{staticClass:"report-footer-powered"},[_vm._v(_vm._s(_vm.$t('report.powered_by')))]),_c('img',{staticClass:"report-footer-logo pb-2 pl-2 pr-2",attrs:{"src":_vm.logo,"alt":_vm.title,"width":"80"}}),_c('span',{staticClass:"report-footer-copy"},[_vm._v("© "+_vm._s(_vm.year))])])
}
var staticRenderFns = []

export { render, staticRenderFns }